import { TFunction } from 'i18next'
import { ListingMetaPayload } from 'newTypes/unit'

type DetailsLike = {
  heat?: boolean
  electricity?: boolean
  internet?: boolean
  petFriendly?: boolean
  pet_friendly?: boolean
  parking?: boolean
  snowRemoval?: boolean
  snow_removal?: boolean
  furnished?: boolean
  semiFurnished?: boolean
  semi_furnished?: boolean
}

type ListingHighlightSource = {
  details?: DetailsLike | null
  listingMeta?: ListingMetaPayload | null
  listing_meta?: ListingMetaPayload | null
  [key: string]: unknown
}

type HighlightDef = {
  id: string
  labelKey: string
  match: (source: ListingHighlightSource) => boolean
}

const HIGHLIGHTS: HighlightDef[] = [
  {
    id: 'pets',
    labelKey: 'propertyCard.highlightPets',
    match: s =>
      Boolean(s.details?.petFriendly || s.details?.pet_friendly) ||
      s.listingMeta?.petsAllowed === 'yes' ||
      s.listingMeta?.petsAllowed === 'conditions' ||
      s.listing_meta?.petsAllowed === 'yes' ||
      s.listing_meta?.petsAllowed === 'conditions',
  },
  {
    id: 'parking',
    labelKey: 'propertyCard.highlightParking',
    match: s =>
      Boolean(s.details?.parking) ||
      Boolean(s.listingMeta?.parking?.type) ||
      Boolean(s.listing_meta?.parking?.type),
  },
  {
    id: 'furnished',
    labelKey: 'propertyCard.highlightFurnished',
    match: s => Boolean(s.details?.furnished),
  },
  {
    id: 'heat',
    labelKey: 'propertyCard.highlightHeat',
    match: s => Boolean(s.details?.heat),
  },
  {
    id: 'internet',
    labelKey: 'propertyCard.highlightInternet',
    match: s => Boolean(s.details?.internet),
  },
  {
    id: 'electricity',
    labelKey: 'propertyCard.highlightElectricity',
    match: s => Boolean(s.details?.electricity),
  },
  {
    id: 'pmr',
    labelKey: 'propertyCard.highlightPmr',
    match: s =>
      Boolean(s.listingMeta?.pmrAccessible || s.listing_meta?.pmrAccessible),
  },
]

/** Up to three relevant differentiators for quick scan on listing cards. */
export function listingCardHighlights(
  t: TFunction,
  source: ListingHighlightSource,
  limit = 3
): string[] {
  const labels: string[] = []
  for (const item of HIGHLIGHTS) {
    if (!item.match(source)) continue
    labels.push(String(t(item.labelKey)))
    if (labels.length >= limit) break
  }
  return labels
}

export function isListingUnavailable(property: {
  status?: string | null
  listingMeta?: { status?: string | null } | null | Record<string, unknown>
  listing_meta?: { status?: string | null } | null | Record<string, unknown>
}): boolean {
  const meta = (property.listingMeta || property.listing_meta) as
    | { status?: string | null }
    | null
    | undefined
  const status = meta?.status || property.status || ''
  const normalized = String(status).trim().toLowerCase()
  if (!normalized) return false
  return normalized !== 'active'
}
